import type { ValidationResult } from '@idem/tipos/validation-result.type';
import type { ValidationOptions } from '@idem/tipos/validation-options.type';

export const validateMinLength =
  (minLength: number) =>
  (validator: ValidationOptions & ValidationResult): ValidationResult => {
    if (validator.code) {
      return validator;
    }
    if (!validator.value || validator.value.length < minLength) {
      return {
        ...validator,
        code: 'too-short',
        message: fieldName => `${fieldName} debe tener largo ${minLength} como mínimo.`,
      };
    }
    return validator;
  };
